var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle xsmall"},[_c('div',{staticClass:"label "},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"indicator",class:{active: _vm.state},on:{"click":_vm.update}},[_vm._v(_vm._s(_vm.state_txt))])])}
var staticRenderFns = []

export { render, staticRenderFns }